import api from './api';

/**
 * Servicio para gestión de organizaciones PostgreSQL
 * 
 * Conecta el frontend con las APIs de organizaciones
 * Permite a administradores gestionar organizaciones y torneos
 */

const organizacionService = {
  /**
   * Obtener todas las organizaciones
   * @returns {Promise<Object>} Lista de organizaciones
   */
  async getOrganizaciones() {
    try {
      const response = await api.get('/postgres/modelos/organizaciones');
      console.log('🏢 organizacionService.getOrganizaciones response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener organizaciones:', error);
      throw error;
    }
  },

  /**
   * Obtener organización por ID del gestor (usuario admin)
   * @param {string} gestorId - ID del usuario gestor
   * @returns {Promise<Object>} Organización del gestor
   */
  async getOrganizacionPorGestor(gestorId) {
    try {
      const response = await api.get(`/postgres/organizaciones/gestor/${gestorId}`);
      console.log('🏢 organizacionService.getOrganizacionPorGestor response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error al obtener organización por gestor:', error);
      throw error;
    }
  },

  /**
   * Crear nueva organización
   * @param {Object} organizacionData - Datos de la organización
   * @returns {Promise<Object>} Organización creada
   */
  async createOrganizacion(organizacionData) {
    try {
      const response = await api.post('/postgres/organizaciones', organizacionData);
      return response.data;
    } catch (error) {
      console.error('Error al crear organización:', error);
      throw error;
    }
  },

  /**
   * Actualizar organización
   * @param {number} id - ID de la organización
   * @param {Object} organizacionData - Datos actualizados
   * @returns {Promise<Object>} Organización actualizada
   */
  async updateOrganizacion(id, organizacionData) {
    try {
      const response = await api.put(`/postgres/organizaciones/${id}`, organizacionData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar organización:', error);
      throw error;
    }
  },

  /**
   * Eliminar organización
   * @param {number} id - ID de la organización
   * @returns {Promise<Object>} Confirmación
   */
  async deleteOrganizacion(id) {
    try {
      const response = await api.delete(`/postgres/organizaciones/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar organización:', error);
      throw error;
    }
  }
};

export default organizacionService;
